module.exports = __webpack_public_path__ + "img/logo-instituto.67cc32cf.png";